module.exports = __webpack_public_path__ + "static/media/old.woman.d5646dab.png";